import { token } from '@atlaskit/tokens';

type IconProps = {
	width?: string | number;
	height?: string | number;
};

export const IntegrationsIcon = ({ width = '24', height = '24' }: IconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="2"
				y="2"
				width="24"
				height="24"
				rx="12"
				fill={token('elevation.surface.sunken')}
				fillOpacity="0.07"
			/>
			<rect
				x="1"
				y="1"
				width="26"
				height="26"
				rx="13"
				stroke={token('color.border.accent.gray')}
				strokeOpacity="0.4"
				strokeWidth="1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.1174 7.54723C16.6097 6.73303 18.5172 6.95696 19.7802 8.21997C21.3157 9.75551 21.3157 12.2451 19.7802 13.7806L17.5302 16.0306L16.4695 14.97L18.7195 12.72C19.6693 11.7702 19.6693 10.2304 18.7195 9.28063C18.0158 8.57693 16.9873 8.39444 16.1157 8.73386C16.2025 8.97317 16.2499 9.23136 16.2499 9.5003C16.2499 10.7429 15.2425 11.7503 13.9999 11.7503C12.7572 11.7503 11.7499 10.7429 11.7499 9.5003C11.7499 8.25766 12.7572 7.2503 13.9999 7.2503C14.4064 7.2503 14.7882 7.35854 15.1174 7.54723ZM13.9999 8.7503C13.5856 8.7503 13.2499 9.08609 13.2499 9.5003C13.2499 9.91452 13.5856 10.2503 13.9999 10.2503C14.4141 10.2503 14.7499 9.91452 14.7499 9.5003C14.7499 9.29829 14.671 9.11627 14.5408 8.98077C14.4034 8.83779 14.2125 8.7503 13.9999 8.7503ZM8.21952 14.22L10.4695 11.97L11.5302 13.0306L9.28018 15.2806C8.33043 16.2304 8.33043 17.7702 9.28018 18.72C9.98388 19.4237 11.0124 19.6062 11.884 19.2667C11.7972 19.0274 11.7499 18.7692 11.7499 18.5003C11.7499 17.2577 12.7572 16.2503 13.9999 16.2503C15.2425 16.2503 16.2499 17.2577 16.2499 18.5003C16.2499 19.7429 15.2425 20.7503 13.9999 20.7503C13.5933 20.7503 13.2115 20.6421 12.8823 20.4534C11.39 21.2676 9.48253 21.0436 8.21952 19.7806C6.68399 18.2451 6.68399 15.7555 8.21952 14.22ZM13.9999 17.7503C13.5856 17.7503 13.2499 18.0861 13.2499 18.5003C13.2499 18.7023 13.3287 18.8843 13.4589 19.0198C13.5963 19.1628 13.7872 19.2503 13.9999 19.2503C14.4141 19.2503 14.7499 18.9145 14.7499 18.5003C14.7499 18.0861 14.4141 17.7503 13.9999 17.7503Z"
				fill={token('color.icon.accent.gray')}
			/>
		</svg>
	);
};
